import { formatDateLocal } from "./dateFormat";
import { getDatePreset } from "./datePresets";

export const setDefaultLast30Days = () => {
  const [dateFrom, dateUntil] = getDatePreset("last30") || [new Date(), new Date()];
  localStorage.setItem("globalDateFrom", formatDateLocal(dateFrom));
  localStorage.setItem("globalDateUntil", formatDateLocal(dateUntil));
};

